export const ingredientReducer = (
	state = {
		list: undefined,
		count: 0,
		ingredientData: [],
		ingredientDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "INGREDIENT_LIST_SUCCESS":
		case "INGREDIENT_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				ingredientData: action.payload.ingredientData,
			};
		case "INGREDIENT_DETAILS":
			return {
				...state,
				ingredientDetails: action.payload,
			};
		// case "INGREDIENT_DETAILS":
		// 	return {
		// 		...state,
		// 		ingredientDetails: undefined,
		// 	};
		case "INGREDIENT_TOGGLE_SUCCESS":
			return {
				...state,
				ingredientDetails: { ...state?.ingredientDetails, isActive: !state?.ingredientDetails?.isActive },
			};
		case "INGREDIENT_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
